// extracted by mini-css-extract-plugin
var _1 = "FakeSelectionButton-module__fakeSelection--cl9BL";
export { _1 as "fakeSelection" }
